export default "__VITE_ASSET__BDXiw$jn__"